export const RATIO_CODE = {
  TOTAL_RATIO: 'RT0033',
  OWNER_EQUITY: 'RT0417',
  TOTAL_AVG: 'RTG0033',
  OWNER_EQUITY_AVG: 'RTG0417',
}

export const TREND_DATA = [
  {
    value: RATIO_CODE.TOTAL_AVG,
    color: '#c8ebfe',
    width: 'calc(100% - 3px)',
    dotColor: '#06a4f9',
    disableFill: false,
  },
  {
    value: RATIO_CODE.OWNER_EQUITY_AVG,
    color: '#fff0a0',
    width: 'calc(50% - 3px)',
    dotColor: '#ffd900',
    disableFill: false,
  },
  {
    value: RATIO_CODE.TOTAL_RATIO,
    color: '#66c7ff',
    width: 'calc(50% - 3px)',
    dotColor: '#006aa6',
    disableFill: true,
  },
  {
    value: RATIO_CODE.OWNER_EQUITY,
    color: '#ffefcc',
    width: 'calc(50% - 3px)',
    dotColor: '#ffcd60',
    disableFill: true,
  },
]
